import { render, staticRenderFns } from "./NotiIcon.vue?vue&type=template&id=0adbd48c&"
import script from "./NotiIcon.vue?vue&type=script&lang=js&"
export * from "./NotiIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports